import { render, staticRenderFns } from "./fdleorirates.vue?vue&type=template&id=8f792a44&scoped=true&"
import script from "./fdleorirates.vue?vue&type=script&lang=js&"
export * from "./fdleorirates.vue?vue&type=script&lang=js&"
import style0 from "./fdleorirates.vue?vue&type=style&index=0&id=8f792a44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f792a44",
  null
  
)

export default component.exports